import { commonBlockElements } from "./CommonBlockElements.const";

const cleanupRegex = new RegExp(`\\r?\\n|\\t|( ) +|(\\/(?:${commonBlockElements.join("|")})>)\\s+(<)`, "g");

export function cleanupWhitespaceInHtmlString(htmlString: string): string {
    return htmlString.replace(cleanupRegex, "$1$2$3");
}
